import PropTypes from 'prop-types';
import Gap from 'src/components/atoms/Gap';
import Row from '../../atoms/Row/Row';
import SkeletonPiece, { SkeletonPieceColor } from '../../atoms/SkeletonPiece';
import { Container } from './styles';

export type LoaderTeamListProps = {
  rows?: number;
};

const LoaderTeamList: React.FC<LoaderTeamListProps> = (props) => {
  const { rows } = props;
  return (
    <Row columns={2} gap={1.5} wrap={'wrap'} justify="center" data-testid="LoaderTeamList">
      {Array(rows)
        .fill(0)
        .map((_, i) => {
          return (
            <Container key={i}>
              <Row justify="space-between">
                <Row.Col size={'80%'}>
                  <SkeletonPiece width={70} height={15} color={SkeletonPieceColor.gray200} />
                  <Gap height={0.9} />
                  <SkeletonPiece width={180} height={20} color={SkeletonPieceColor.gray50} />
                  <Gap height={0.5} />
                  <SkeletonPiece width={90} height={20} color={SkeletonPieceColor.gray100} />
                  <Gap height={0.9} />
                  <SkeletonPiece width={70} height={15} color={SkeletonPieceColor.gray50} />
                  <Gap height={0.5} />
                  <SkeletonPiece width={90} height={20} color={SkeletonPieceColor.gray100} />
                </Row.Col>
                <Row.Col size={'auto'} alignSelf="flex-start">
                  <Row gap={1} className={'Skeleton___Box'} justify={'flex-end'}>
                    <SkeletonPiece width={20} height={20} color={SkeletonPieceColor.gray200} />
                  </Row>
                </Row.Col>
              </Row>
            </Container>
          );
        })}
    </Row>
  );
};
LoaderTeamList.propTypes = {
  rows: PropTypes.number
};

LoaderTeamList.defaultProps = {
  rows: 4
};

export default LoaderTeamList;
